import { ExportToCsv } from "export-to-csv";
import { errorNotify, sucessNotify } from "../../../services/toast.notification";
import { ButtonContainer } from "../../FormContainer/styles";
import { Button } from "antd";


  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    title: 'فاکتور',
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    fileName :'Tax.csv'
  };

  
const ConvertToExcel = (data:any) =>{
       if (!data) {
          errorNotify("داده ای جهت خروجی وجود ندارد");
          return;
        }
    
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(data);
        sucessNotify("فایل خروجی با موفقیت ساخته شد");
    
      }

export default ConvertToExcel;
